import { EPostbackStatus } from '../../enum'

// Create a union type of all possible values from the enum
type IPostbackStatusLangKey = `${EPostbackStatus}`

export type IPostbackStatusLang = {
	postback_status: Record<IPostbackStatusLangKey, string>
}

const langEntries = Object.entries(EPostbackStatus).map(
	([key, value]) => [value, `postback_status.${value}`]
)

const langObj: Record<IPostbackStatusLangKey, string> = Object.fromEntries(langEntries)

export const POSTBACK_STATUS_LANG_KEY: IPostbackStatusLang = {
	postback_status: langObj
}
